import { useQuery } from "@tanstack/react-query";
import { ApiService } from "@/services/api/ApiService";
import { ConversationLogsService } from "@/services/communication/ConversationLogsService";
import type { ConversationLogFilters } from "@/types/conversation-logs";

export const useConversationLogs = (filters?: ConversationLogFilters, page: number = 1, pageSize: number = 50, enabled: boolean = true) => {
  return useQuery({
    queryKey: ["conversation-logs", filters, page, pageSize],
    queryFn: () => ConversationLogsService.getConversationLogs(filters, pageSize, (page - 1) * pageSize),
    staleTime: 1000 * 60,
    refetchInterval: enabled ? 1000 * 60 : false,
    enabled,
  });
};

export const useConversationLog = (id: number) => {
  return useQuery({
    queryKey: ["conversation-log", id],
    queryFn: () => ConversationLogsService.getConversationLog(id),
    enabled: !!id,
  });
};

export const useConversationLogDetails = (logId: number) => {
  return useQuery({
    queryKey: ["conversation-log-details", logId],
    queryFn: () => ConversationLogsService.getConversationLogDetails(logId),
    staleTime: 0,
    refetchInterval: 1000 * 60,
    refetchOnMount: true,
    enabled: !!logId,
  });
};

export const useConversationLogStats = (filters?: ConversationLogFilters, enabled: boolean = true) => {
  return useQuery({
    queryKey: ["conversation-log-stats", filters],
    queryFn: () => ConversationLogsService.getConversationLogStats(filters),
    staleTime: 1000 * 60,
    refetchInterval: enabled ? 1000 * 60 : false,
    enabled,
  });
};

export const useElevenLabsConversationData = (conversationId: string | null) => {
  return useQuery({
    queryKey: ["elevenlabs-conversation", conversationId],
    queryFn: async () => {
      const data = await ApiService.callEdge<any>("elevenlabs", {
        resource: "conversations",
        action: "get",
        params: {
          entityId: conversationId!,
        },
      });
      return data;
    },
    enabled: !!conversationId,
  });
};
